import { USER_TYPE } from "constants";

export function isUserHost(user) {
  if (!user || !user.role) return false;
  return user.role.find((role) => role.user_type === USER_TYPE.HOST);
}
